import produce from 'immer';
import { cloneDeep } from 'lodash';
import { IPlayoutScreen, IPlayoutState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import { IPlayoutUrlAction } from '../actions/playoutActions';
export const initialPlayoutState: IPlayoutState = {
  playoutIds: [],
  playoutMap: {},
  webRTCConfigHash: {},
  isFetching: false
};

const playoutReducer = (
  state = initialPlayoutState,
  action: IPlayoutUrlAction
): IPlayoutState => {
  const playoutIds: string[] = [];
  const playoutMap: { [key: string]: IPlayoutScreen } = {};

  return produce(state, (draft: IPlayoutState) => {
    switch (action.type) {
      case actionTypes.FETCH_PLAYOUT_URLS_SUCCESS:
        draft.isFetching = false;
        if (action.payload) {
          action.payload.map((playout: any) => {
            const {
              ice_servers,
              use_websocket_for_webrtc,
              ice_transport_policy
            } = playout.ice_server_details;
            const iceServers =
              ice_servers &&
              ice_servers.filter(
                ({ url, credential, username }) => url && credential && username
              );
            draft.webRTCConfigHash[playout.customer] = {
              iceServers,
              iceTransportPolicy: ice_transport_policy,
              useWebSocketForWebRTC: use_websocket_for_webrtc
            };
            if (playout.playout) {
              Object.keys(playout.playout).map((feedCode: string) => {
                if (
                  feedCode !== 'default' &&
                  action.feedCodes.indexOf(feedCode) !== -1
                ) {
                  playout.playout[feedCode].map((feedInfo: any) => {
                    const playoutId = `${playout.customer}#${feedCode}#${feedInfo.headend}`;
                    if (feedInfo && feedInfo.url && feedInfo.headend) {
                      const playoutScreen = {
                        ...feedInfo,
                        customer: playout.customer,
                        feed_code: feedCode
                      };
                      playoutMap[playoutId] = playoutScreen;
                      if (playoutIds.indexOf(playoutId) === -1) {
                        playoutIds.push(playoutId);
                      }
                    }
                  });
                }
              });
            }
          });
        }
        draft.playoutIds = playoutIds;
        draft.playoutMap = playoutMap;
        break;
      case actionTypes.FETCH_PLAYOUT_URLS_PENDING:
        draft.isFetching = true;
        break;
      case actionTypes.UPDATE_PLAYOUT_FEEDS:
        action.feeds.map(feed => {
          const feedId = `${feed.customer}#${feed.feed_code}#${feed.headend}`;
          if (draft.playoutMap[feedId]) {
            const messages = [];
            if (feed.errors && Object.keys(feed.errors).length > 0) {
              Object.keys(feed.errors).forEach(index => {
                const value = feed.errors[index];
                messages.unshift({
                  id: `${value.timestamp}_${index}`,
                  dataKey: 'id',
                  type: index,
                  code: index,
                  feed_id: feedId,
                  description: value.description,
                  timestamp: value.timestamp,
                  title: value.title,
                  customer: feed.customer,
                  feed_code: feed.feed_code,
                  headend: feed.headend,
                  last_checked: feed.last_checked,
                  name: feed.name,
                  status: feed.status,
                  received_at: cloneDeep(feed.received_at),
                  ended_at: undefined
                });
              });
            }

            if (feed.warnings && Object.keys(feed.warnings).length > 0) {
              Object.keys(feed.warnings).forEach(index => {
                const value = feed.warnings[index];
                messages.unshift({
                  id: `${value.timestamp}_${index}`,
                  type: index,
                  code: index,
                  feed_id: feedId,
                  dataKey: 'id',
                  description: value.description,
                  timestamp: value.timestamp,
                  title: value.title,
                  customer: feed.customer,
                  feed_code: feed.feed_code,
                  headend: feed.headend,
                  last_checked: feed.last_checked,
                  status: feed.status,
                  received_at: cloneDeep(feed.received_at),
                  ended_at: undefined
                });
              });
            }

            draft.playoutMap[feedId] = {
              ...draft.playoutMap[feedId],
              errors: feed.errors ? feed.errors : {},
              warnings: feed.warnings ? feed.warnings : {},
              status: feed.status ? feed.status : '',
              last_checked: feed.last_checked ? feed.last_checked : '',
              messages,
              not_ended_messages: []
            };
          }
        });
        break;
      default:
        break;
    }
  });
};

export default playoutReducer;
